import React from 'react';

import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';

import styled from 'styled-components';
import { Helmet } from 'react-helmet-async';
import PageWrapper from '../components/pageWrapperHOC';
import Feedback from '../components/srp/Feedback';
import FAQ from '../components/srp/FAQ';
import { SRPContextProvider } from '../common/context/srpContext';
import HeroBanner from '../components/srp/HeroBanner';
import TermsOfUse from '../components/srp/TermsOfUse';
import Partners from '../components/srp/Partners';
import { getBaseURL } from '../common/utilities';

const Index = (props) => {
  const { store, currentPath } = props;
  const navigate = useNavigate();
  const params = useParams();

  const navigateToUrl = (path) => {
    const baseUrl = getBaseURL(params.locale, path);
    navigate(baseUrl);
  };
  return (
    <SRPContextProvider store={store} currentPath={currentPath} navigateToUrl={navigateToUrl}>
      <PageWrapper>
        <Helmet key="helmet">
          <title>
            Partner Finder | Autodesk Support
          </title>
        </Helmet>
        <RootElement>
          <HeroBanner />
          <Partners />
          <Feedback />
          <FAQ />
          <TermsOfUse />
        </RootElement>
      </PageWrapper>
    </SRPContextProvider>
  );
};

const RootElement = styled.div`
`;

Index.propTypes = {
  store: PropTypes.shape({}),
  currentPath: PropTypes.string,
};

Index.defaultProps = {
  store: {},
  currentPath: '',
};

export default Index;
